/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import styles from './styles.module.scss';
import { useId } from 'react';
type Props = {
  show: boolean | undefined;
  unitPrice: number | null | string | undefined;
};
const labelMap = {
  lblCartEach: 'label_cart_Each',
};

export const UnitPrice = ({ show, unitPrice }: Props) => {
  const unitPriceId = useId();

  const labels = useLabels(labelMap);
  return show ? (
    <span id={unitPriceId} className={styles.unitPriceLabel}>
      {`$${unitPrice} ${labels.lblCartEach}`}
    </span>
  ) : null;
};
